import React from "react";
import {Link} from "react-router-dom";
import '../../../node_modules/react-phone-input-2/lib/style.css';
import "./static/InputPhone.scss";
import PhoneInput from "react-phone-input-2";

const InputPhoneField = (props) => {
    const active = props.textAlign ? "right-input-text" : "";
    const isError = props.isError || "";
    const isDisabled = props.isDisabled || false;
    const disabledClass = isDisabled ? "disabled" : "";
    const isMultiple = props.isMultiple ? true : false;

    return (
        <div className="phone_block">
            <div className={`single-input ${props.className}`}>
                <label htmlFor="">
                    <span className={props.asterisk ? "asterisk name" : "name"}>{props.inputLabel} {props.asterisk && <strong>*</strong>}</span>
                    {props.labelLink && (
                        <span className="link">
                        <Link to={props.labelLink}>{props.labelLinkText}</Link>
                    </span>
                    )}
                    {props.labelOnChangeCallback && (
                        <span className="link">
                        <a href={void (0)} onClick={props.labelOnChangeCallback}>{props.labelLinkText}</a>
                    </span>
                    )}
                </label>
                <PhoneInput
                    id={props.id}
                    inputClass={`input-box ${active} ${isError} ${disabledClass} ${props.inputClassName}`}
                    country={props.country}
                    value={props.value}
                    name={props.inputName}
                    countryCodeEditable={false}
                    onChange={props.onchangeCallback}
                />

                {props.requiredMessage ? (
                    <span className="phn-error-message">
                     {props.requiredMessageLabel}
                </span>
                ) : props.whiteSpace === false ? ''
                    :
                    ' '
                }
            </div>
        </div>
    );
};
export default InputPhoneField;
